import { analytics, type AnalyticsIdentifyProps } from "@/lib/analytics/analytics";

export type AnalyticsUserProfile = {
  id: string;
  username: string;
  is_pro: boolean;
  created_at: string | null;
  auth_provider: string | null;
};

export function toIdentifyProps(
  profile: AnalyticsUserProfile,
): AnalyticsIdentifyProps {
  const provider = profile.auth_provider?.toLowerCase() ?? null;
  const signup_method =
    provider === "google" || provider === "github" ? "oauth" : "username-password";

  return {
    username: profile.username,
    account_type: profile.is_pro ? "pro" : "free",
    signup_method,
    created_at: profile.created_at,
    auth_provider: provider,
  };
}

export function identifyAnalyticsUser(profile: AnalyticsUserProfile): void {
  analytics.identify(profile.id, toIdentifyProps(profile));
}
